import React from 'react';
import PanettoneIndicators from 'components/Tvendo/Sale/QuotaBPartner/WinterCuotas/Panettone/Indicators/List.js';

export default function () {
  return <PanettoneIndicators />;
}
